// client/src/components/Logo.tsx
export default function Logo({ size = 'default' }: { size?: 'small' | 'default' | 'large' }) {
    const sizes = {
        small: 'w-8 h-8',
        default: 'w-10 h-10',
        large: 'w-14 h-14'
    };

    return (
        <img
            src="/expertlogo.png"
            alt="Expert Link Pro"
            className={`${sizes[size]} rounded-lg object-contain`}
        />
    );
}
